import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { FaRegEye } from "react-icons/fa";
import { IoEyeOffOutline } from "react-icons/io5";
import "./AlumniLogin.css";
import "./AlumniPasswordReset.css";

const AlumniNewPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (location.state?.email) {
      setEmail(location.state.email);
    } else {
      navigate("/alumni-forgot-password");
    }
  }, [location.state, navigate]);

  const validateForm = () => {
    const nextErrors = {};

    if (!newPassword) {
      nextErrors.newPassword = "Password is required";
    } else if (newPassword.length < 6) {
      nextErrors.newPassword = "Password must be at least 6 characters";
    }

    if (!confirmPassword) {
      nextErrors.confirmPassword = "Confirm your password";
    } else if (newPassword !== confirmPassword) {
      nextErrors.confirmPassword = "Passwords do not match";
    }

    setErrors(nextErrors);
    return Object.keys(nextErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    try {
      setLoading(true);
      const response = await axios.post(
        "/backend/alumni/reset-password",
        { email, password: newPassword },
        { withCredentials: true }
      );

      if (response.data.success) {
        navigate("/alumni-login", {
          replace: true,
          state: { message: response.data.message || "Password reset successfully" },
        });
      } else {
        setErrors((prev) => ({
          ...prev,
          form: response.data.message || "Failed to reset password",
        }));
      }
    } catch (error) {
      const message =
        error?.response?.data?.message || "Failed to reset password. Please try again.";
      setErrors((prev) => ({
        ...prev,
        form: message,
      }));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="alumni-login-page">
      <div className="alumni-login-card">
        <h1 className="alumni-login-title"> Reset Password</h1>
        <div className="alumni-login-line"></div>

        <p className="alumni-reset-helper">
          Create a new password for <strong>{email}</strong>.
        </p>

        {errors.form && <p className="alumni-page-message error">{errors.form}</p>}

        <form onSubmit={handleSubmit}>
          <div className="alumni-input-group">
            <label htmlFor="newPassword">New Password</label>
            <div className="alumni-password-box">
              <input
                id="newPassword"
                type={showPassword ? "text" : "password"}
                placeholder="Create a new password"
                value={newPassword}
                onChange={(e) => {
                  setNewPassword(e.target.value);
                  setErrors((prev) => ({ ...prev, newPassword: "", form: "" }));
                }}
                aria-invalid={Boolean(errors.newPassword)}
              />
              <button
                type="button"
                className="alumni-eye-btn"
                onClick={() => setShowPassword((prev) => !prev)}
              >
                {showPassword ? <IoEyeOffOutline size={22} /> : <FaRegEye size={20} />}
              </button>
            </div>
            {errors.newPassword && <p className="alumni-field-error">{errors.newPassword}</p>}
          </div>

          <div className="alumni-input-group">
            <label htmlFor="confirmPassword">Confirm Password</label>
            <div className="alumni-password-box">
              <input
                id="confirmPassword"
                type={showConfirmPassword ? "text" : "password"}
                placeholder="Confirm your password"
                value={confirmPassword}
                onChange={(e) => {
                  setConfirmPassword(e.target.value);
                  setErrors((prev) => ({ ...prev, confirmPassword: "", form: "" }));
                }}
                aria-invalid={Boolean(errors.confirmPassword)}
              />
              <button
                type="button"
                className="alumni-eye-btn"
                onClick={() => setShowConfirmPassword((prev) => !prev)}
              >
                {showConfirmPassword ? <IoEyeOffOutline size={22} /> : <FaRegEye size={20} />}
              </button>
            </div>
            {errors.confirmPassword && <p className="alumni-field-error">{errors.confirmPassword}</p>}
          </div>

          <button type="submit" className="alumni-login-btn" disabled={loading}>
            {loading ? "Changing Password..." : "Change Password"}
          </button>

          <div className="alumni-register-text">
            <Link to="/alumni-login">Back to Login</Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AlumniNewPassword;
